   
import React from "react";
import "./CustomMarquee.scss";

const CustomMarquee = ({ direction = "up", speed = 30, children }: any) => {
  return (
    <div className={`marquee-container marquee-${direction}`} style={{ "--speed": `${speed}s` }}>
      <div className="marquee-content">
        {children}
        {children} {/* duplicate for infinite loop */}
      </div>
    </div>
  );
};

export default CustomMarquee;
